<div class="wrapper">
    <Nav configuration></Nav>
    <div class="general">
        <Menu></Menu>
        <main class="main">
            <div class="order">
                <div class="container">
                    <div class="order__wrap">
                        <div class="order__header">
                            <a href="/service" class="button button--border button--no-uppercase-border">Добавить новый</a>
                            <div class="order-info">
                                <div class="order-info__left">
                                    <div class="order-info__data">
                                        <div class="order-info__row">
                                            <div class="order-info__column">
                                                <span class="order-info__category">Количество деталей:</span>
                                                <span class="order-info__value">{total_count} шт</span>
                                            </div>
                                            <div class="order-info__column">
                                                <span class="order-info__category">Адрес доставки:</span>
                                                <span class="order-info__value">
                                                    <a href="#" class="button button--icons">
                                                        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M13.569 13.8421H5.80973C5.69541 13.8421 5.58576 13.7967 5.50492 13.7159C5.42408 13.635 5.37866 13.5254 5.37866 13.4111C5.37866 13.2967 5.42408 13.1871 5.50492 13.1062C5.58576 13.0254 5.69541 12.98 5.80973 12.98H13.569C13.6833 12.98 13.793 13.0254 13.8738 13.1062C13.9547 13.1871 14.0001 13.2967 14.0001 13.4111C14.0001 13.5254 13.9547 13.635 13.8738 13.7159C13.793 13.7967 13.6833 13.8421 13.569 13.8421Z" fill="#6A96F8" />
                                                            <path d="M1.49891 13.842C1.43402 13.842 1.36997 13.8273 1.31155 13.799C1.25313 13.7708 1.20184 13.7297 1.1615 13.6789C1.12117 13.628 1.09283 13.5688 1.0786 13.5054C1.06438 13.4421 1.06463 13.3764 1.07933 13.3132L1.70582 10.6521C1.72408 10.5737 1.7639 10.5021 1.82078 10.4452L9.74673 2.52496C9.99275 2.28958 10.3201 2.1582 10.6606 2.1582C11.0011 2.1582 11.3284 2.28958 11.5745 2.52496L12.3849 3.33537C12.6271 3.57785 12.7631 3.90654 12.7631 4.24924C12.7631 4.59194 12.6271 4.92063 12.3849 5.16311L4.46467 13.0891C4.40778 13.1459 4.33611 13.1858 4.25776 13.204L1.59662 13.842H1.49891ZM2.50474 10.9682L2.06792 12.8304L3.93015 12.3936L11.7756 4.55386C11.8564 4.47304 11.9017 4.36348 11.9017 4.24924C11.9017 4.13501 11.8564 4.02544 11.7756 3.94462L10.9652 3.13421C10.883 3.05618 10.774 3.01268 10.6606 3.01268C10.5472 3.01268 10.4382 3.05618 10.356 3.13421L2.50474 10.9682Z" fill="#6A96F8" />
                                                        </svg>
                                                    </a>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="order-info__row">
                                            <div class="order-info__column">
                                                <span class="order-info__category">Общая стоимость:</span>
                                                <span class="order-info__value">{total_cost.toFixed()} ₽</span>
                                            </div>
                                            <div class="order-info__column">
                                                <span class="order-info__category">Дата доставки:</span>
                                                <span class="order-info__value">{total_date}</span>
                                            </div>
                                        </div>
                                        <div class="order-info__row">
                                            <div class="order-info__column">
                                                <span class="order-info__category">Цена доставки:</span>
                                                <span class="order-info__value">562 ₽</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="order-info__total">
                                        <span class="order-info__category">Итоговая стоимость</span>
                                        <span class="order-info__price">{(total_cost+562).toFixed()} ₽</span>
                                    </div>
                                </div>
                                <div class="order-info__right">
                                    <a href="#" class="button" class:button--disabled={total_cost==0}>Оформить заказ</a>
                                </div>
                            </div>
                        </div>
                        <div class="order-table">
                            <div class="order-table__row order-table__row-header">
                                <div class="order-table__column">
                                    <div class="checkbox">
                                        <input type="checkbox" id="checkbox1" bind:this={check_all} on:change={selectAll}>
                                        <label for="checkbox1"></label>
                                    </div>
                                </div>
                                <div class="order-table__column">
                                    <a href="#" class="button button--sorting">
                                        Название
                                        <img src="/images/content/arrow.svg">
                                    </a>
                                </div>
                                <div class="order-table__column">
                                    <a href="#" class="button button--sorting">
                                        Конфигурации
                                        <img src="/images/content/arrow.svg">
                                    </a>
                                </div>
                                <div class="order-table__column">
                                    <a href="#" class="button button--sorting">
                                        Срок изготовления
                                        <img src="/images/content/arrow.svg">
                                    </a>
                                </div>
                                <div class="order-table__column">
                                    <a href="#" class="button button--sorting">
                                        Количество
                                        <img src="/images/content/arrow.svg">
                                    </a>
                                </div>
                                <div class="order-table__column">
                                    <a href="#" class="button button--sorting">
                                        Цена
                                        <img src="/images/content/arrow.svg">
                                    </a>
                                </div>
                                <div class="order-table__column"></div>
                            </div>
                            {#each orders as order,i}
                            <div class="order-table__row">
                                <div class="order-table__column">
                                    <div class="checkbox">
                                        <input type="checkbox" id={"checkbox-"+i.toString()}  bind:checked={order.checked}>
                                        <label for={"checkbox-"+i.toString()}></label>
                                    </div>
                                </div>
                                <div class="order-table__column">
                                    <div class="order-table__prev" align="center">
                                        <div class="order-table__img" align="center">
                                            <img src={order.Preview} alt="">
                                        </div>
                                        <span class="order-table__sign">{order.FileName}</span>
                                    </div>
                                </div>
                                <div class="order-table__column">
                                    <div class="order-table__vertical">
                                        <span class="order-table__name">
                                            {order.comment}
                                        </span>
                                        <a href="#" class="button-link order-table__button-link">Изменить</a>
                                    </div>
                                </div>
                                <div class="order-table__column">
                                    <Select list={dates} bind:current={order.date} date></Select>
                                </div>
                                <div class="order-table__column">
                                    <div class="counter">
                                        <button class="counter__button counter__button--left" on:click={()=>{order.count-=1;order.count = order.count<1 ? 1 : order.count}}>
                                            <svg width="10" height="2" viewBox="0 0 10 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M4.61538 0.5H0.416667C0.186548 0.5 0 0.679087 0 0.9C0 1.12091 0.186548 1.3 0.416667 1.3H4.61538H5.44872H9.58333C9.81345 1.3 10 1.12091 10 0.9C10 0.679087 9.81345 0.5 9.58333 0.5H5.44872H4.61538Z" fill="#5C5C5C" />
                                            </svg>
                                        </button>
                                        <input type="number" class="counter__number" bind:value={order.count}>
                                        <button class="counter__button counter__button--right" on:click={()=>{order.count+=1}}>
                                            <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M5.44872 0.916667C5.44872 0.686548 5.26217 0.5 5.03205 0.5C4.80193 0.5 4.61538 0.686548 4.61538 0.916667V5.05128H0.416667C0.186548 5.05128 0 5.23783 0 5.46795C0 5.69807 0.186548 5.88461 0.416667 5.88461H4.61538V10.0833C4.61538 10.3135 4.80193 10.5 5.03205 10.5C5.26217 10.5 5.44872 10.3135 5.44872 10.0833V5.88461H9.58333C9.81345 5.88461 10 5.69807 10 5.46795C10 5.23783 9.81345 5.05128 9.58333 5.05128H5.44872V0.916667Z" fill="#5C5C5C" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                                <div class="order-table__column">
                                    <div class="price">
                                        <span class="price__small">1 шт: {order.cost.toFixed()} ₽</span>
                                        <span class="price__total">Итого: {(order.cost*order.count).toFixed()} ₽</span>
                                    </div>
                                </div>
                                {#if order.delete_dialog}
                                <div class="order-table__column">
                                    <a href="#" class="button button--img">
                                        <svg width="34" height="31" viewBox="0 0 34 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M32.8741 0.957031C33.4959 0.957031 34 1.46113 34 2.08297C34 2.7048 33.4959 3.2089 32.8741 3.2089H29.1327C27.2692 7.8243 25.4336 12.4481 23.5851 17.072L25.2857 21.1652C25.4282 21.5065 25.3881 21.918 25.1825 22.2253C24.9768 22.5327 24.6117 22.7266 24.2419 22.7251H5.47632C4.88149 22.7334 4.33436 22.1941 4.33436 21.5992C4.33436 21.0043 4.88149 20.4648 5.47632 20.4732H22.553L21.5795 18.151L3.50593 16.7084C3.03285 16.6712 2.60462 16.3027 2.49728 15.8405L0.245412 6.08238C0.0981395 5.42513 0.674355 4.70795 1.34789 4.71015H26.1067L27.3265 1.66074C27.4935 1.24797 27.9251 0.957046 28.3703 0.957031H32.8741ZM25.2036 6.96202H2.76702L4.51458 14.5386L21.6264 15.8991L25.2036 6.96202ZM20.4888 23.4757C22.5482 23.4757 24.2419 25.1694 24.2419 27.2288C24.2419 29.2883 22.5482 30.982 20.4888 30.982C18.4293 30.982 16.7357 29.2883 16.7357 27.2288C16.7357 25.1694 18.4293 23.4757 20.4888 23.4757ZM9.22943 23.4757C11.2889 23.4757 12.9825 25.1694 12.9825 27.2288C12.9825 29.2883 11.2889 30.982 9.22943 30.982C7.16999 30.982 5.47632 29.2883 5.47632 27.2288C5.47632 25.1694 7.16999 23.4757 9.22943 23.4757ZM20.4888 25.7276C19.6463 25.7276 18.9875 26.3864 18.9875 27.2288C18.9875 28.0713 19.6463 28.7301 20.4888 28.7301C21.3312 28.7301 21.99 28.0713 21.99 27.2288C21.99 26.3864 21.3312 25.7276 20.4888 25.7276ZM9.22943 25.7276C8.38705 25.7276 7.72819 26.3864 7.72819 27.2288C7.72819 28.0713 8.38705 28.7301 9.22943 28.7301C10.0719 28.7301 10.7307 28.0713 10.7307 27.2288C10.7307 26.3864 10.0719 25.7276 9.22943 25.7276Z" fill="white" />
                                        </svg>
                                        Оформить заказ
                                    </a>
                                    <div class="order-table__delete">
                                        <div class="order-delete">
                                            <div class="order-delete__top">
                                                <span class="order-delete__text">Удалить?</span>
                                            </div>
                                            <div class="order-delete__bottom">
                                                <button on:click={()=>{deleteOrder(order.ID)}} class="order-delete__button">Да</button>
                                                <button on:click={()=>{order.delete_dialog=false}} class="order-delete__button">Нет</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {:else}
                                <div class="order-table__column">
                                    <a href="#" class="button button--img">
                                        <svg width="34" height="31" viewBox="0 0 34 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M32.8741 0.957031C33.4959 0.957031 34 1.46113 34 2.08297C34 2.7048 33.4959 3.2089 32.8741 3.2089H29.1327C27.2692 7.8243 25.4336 12.4481 23.5851 17.072L25.2857 21.1652C25.4282 21.5065 25.3881 21.918 25.1825 22.2253C24.9768 22.5327 24.6117 22.7266 24.2419 22.7251H5.47632C4.88149 22.7334 4.33436 22.1941 4.33436 21.5992C4.33436 21.0043 4.88149 20.4648 5.47632 20.4732H22.553L21.5795 18.151L3.50593 16.7084C3.03285 16.6712 2.60462 16.3027 2.49728 15.8405L0.245412 6.08238C0.0981395 5.42513 0.674355 4.70795 1.34789 4.71015H26.1067L27.3265 1.66074C27.4935 1.24797 27.9251 0.957046 28.3703 0.957031H32.8741ZM25.2036 6.96202H2.76702L4.51458 14.5386L21.6264 15.8991L25.2036 6.96202ZM20.4888 23.4757C22.5482 23.4757 24.2419 25.1694 24.2419 27.2288C24.2419 29.2883 22.5482 30.982 20.4888 30.982C18.4293 30.982 16.7357 29.2883 16.7357 27.2288C16.7357 25.1694 18.4293 23.4757 20.4888 23.4757ZM9.22943 23.4757C11.2889 23.4757 12.9825 25.1694 12.9825 27.2288C12.9825 29.2883 11.2889 30.982 9.22943 30.982C7.16999 30.982 5.47632 29.2883 5.47632 27.2288C5.47632 25.1694 7.16999 23.4757 9.22943 23.4757ZM20.4888 25.7276C19.6463 25.7276 18.9875 26.3864 18.9875 27.2288C18.9875 28.0713 19.6463 28.7301 20.4888 28.7301C21.3312 28.7301 21.99 28.0713 21.99 27.2288C21.99 26.3864 21.3312 25.7276 20.4888 25.7276ZM9.22943 25.7276C8.38705 25.7276 7.72819 26.3864 7.72819 27.2288C7.72819 28.0713 8.38705 28.7301 9.22943 28.7301C10.0719 28.7301 10.7307 28.0713 10.7307 27.2288C10.7307 26.3864 10.0719 25.7276 9.22943 25.7276Z" fill="white" />
                                        </svg>
                                        Оформить заказ
                                    </a>
                                    <a on:click={()=>{order.delete_dialog=true}} class="button button--img button--delete">
                                        <svg width="30" height="35" viewBox="0 0 30 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M24.8464 14.1336C25.1332 14.1336 25.4066 14.2501 25.6016 14.4585C25.7988 14.6669 25.9019 14.9448 25.8862 15.2294C25.6867 18.8507 25.0638 30.1965 25.0638 30.1965C25.0638 32.6705 23.0156 34.3198 20.5416 34.3198H9.40868C6.93694 34.3198 4.88874 32.7825 4.88874 30.3085C4.88874 30.3085 4.147 18.8888 3.9117 15.2406C3.89153 14.9537 3.99462 14.6714 4.18958 14.463C4.38678 14.2523 4.66241 14.1336 4.94925 14.1336C8.72968 14.1336 21.0839 14.1336 24.8464 14.1336ZM1.74486 11.8926C1.09051 11.8948 0.559413 11.3682 0.554932 10.7161C0.557173 10.7071 0.557173 10.6982 0.557173 10.6892C0.557173 9.76148 1.11964 8.96595 1.91965 8.62309C2.93927 8.08303 5.68664 7.63932 9.29676 7.40851V3.84769C9.29676 2.10425 10.713 0.687988 12.4565 0.687988H17.3506C19.0941 0.687988 20.5103 2.10425 20.5103 3.84769V7.40851C24.1205 7.63932 26.8678 8.08303 27.8874 8.62309C28.6875 8.96595 29.2499 9.76148 29.2499 10.6892C29.2499 11.3548 28.7121 11.8926 28.0465 11.8926C23.8964 11.8926 5.85695 11.8926 1.74486 11.8926ZM16.4701 4.25724H13.3373C12.9653 4.25724 12.6628 4.55977 12.6628 4.93176V7.26456C13.3911 7.24888 14.1396 7.23991 14.9037 7.23991C15.6679 7.23991 16.4163 7.24888 17.1446 7.26456V4.93176C17.1446 4.55977 16.8421 4.25724 16.4701 4.25724Z" fill="#6A96F8" />
                                        </svg>
                                        Удалить
                                    </a>
                                </div>
                                {/if}
                            </div>
                            {/each}
                        </div>
                        <div class="order__footer">
                            <a href="#" class="button" class:button--disabled={total_cost==0}>Оформить заказ</a>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</div>
<script type="text/javascript">
import axios from 'axios'
import Nav from './Nav.svelte'
import Menu from './Menu.svelte'
import Select from './Select.svelte'
import {beforeUpdate} from 'svelte'

let orders = []

function updateList() {
    axios.get("/api/orders").then(function(response) {
        orders = response.data
    })
}
updateList()

function deleteOrder(id) {
    axios.post("/api/delete-order", { id }).then(function() {
        updateList()
    })
}

let check_all

function selectAll() {
    orders.forEach((e, i) => {
        e.checked = check_all.checked
    })
    orders = [...orders]
}

let params

function getParams() {
    axios.get("/api/params").then(function(response) {
        params = JSON.parse(response.data)
    })
}
let dates = [
    new Date(Date.now() + 1 * 24 * 3600 * 1000),
    new Date(Date.now() + 3 * 24 * 3600 * 1000),
    new Date(Date.now() + 7 * 24 * 3600 * 1000),
    new Date(Date.now() + 14 * 24 * 3600 * 1000),
]
let date


let total_cost = 0
let total_count = 0
let total_date = ''

beforeUpdate(function() {
        total_cost = 0
        total_count = 0
        total_date = 0
        orders.forEach((order) => {
            if (order.checked) {
                total_cost += order.cost * order.count
                total_count += order.count
                if (total_date < order.date) {
                    total_date = order.date
                }
            }
        })
})
</script>